import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { withRouter, Switch, Route } from 'react-router';
import BreadcrumbsComponent from '../../core/BreadcrumbsComponent/BreadcrumbsComponent';
import MenuComponent, { MENU_PROP_TYPES } from '../../core/MenuComponent/MenuComponent';

import ImageryUsageLayout from '../../../layouts/ImageryUsage/ImageryUsageLayout';
import OverviewReqLayout from '../../../layouts/OverviewReq/OverviewReqLayout';
import LogoUsageLayout from '../../../layouts/LogoUsage/LogoUsageLayout';
import LangLegalNamingLayout from '../../../layouts/LangLegalNaming/LangLegalNamingLayout';

import './marketing.scss';

class MarketingComponent extends React.Component {
    render() {
        const props = this.props;
        const { menuItem } = props.match.params;

        if (!menuItem) {
            return <Redirect to={`/marketing/overviewrequirements`} />;
        }

        return <div className="Developer-sdk-component container">
            <BreadcrumbsComponent />
            <div className="content">
                <MenuComponent {...props} />
                <div className="content-wrapper">
                    <Switch>
                        <Route path='/marketing/overviewrequirements' component={() =>
                            <OverviewReqLayout
                            />
                        } />
                        <Route path='/marketing/logo-usage' component={() =>
                            <LogoUsageLayout
                            />
                        } />
                        <Route path='/marketing/imagery-usage' component={() =>
                            <ImageryUsageLayout
                            />
                        } />
                        <Route path='/marketing/language-legal-naming' component={() =>
                            <LangLegalNamingLayout
                            />
                        } />
                    </Switch>
                </div>
            </div>
        </div>;
    }
}

MarketingComponent.propTypes = {
    ...MENU_PROP_TYPES,
    match: PropTypes.object.isRequired,
};

export default withRouter(MarketingComponent);



// WEBPACK FOOTER //
// ./src/components/marketingGuidelines/marketingComponents/MarketingComponent.js